
import Vue, { PropType } from 'vue'

// import JDateField from '@/ui/controls/JDateField.vue'

import LogTimelineByDateDay from '@/ui/components/timeline/LogTimelineByDateDay.vue'

import LogItem from '@/models/LogItem'

// import { sortByDate } from '@/helpers/sorters'
import { dateOnly } from '@/types/models'
import { parseISO, format } from 'date-fns'

export default Vue.extend({
  components: {
    // JDateField,

    LogTimelineByDateDay,
  },
  props: {
    value: {
      type: Array as PropType<Array<LogItem>>,
      default: (): Array<LogItem> => [],
    },
    category: String,
    hideFilter: Boolean,
    hidePlants: Boolean,
    dense: Boolean,

    imageId: String,
  },
  data: () => ({
    categoryFilter: [] as string[],
    typeFilter: [] as string[],
    sortOrder: -1 as 1 | -1,
    // addItems: 0,

    // startDate: format(addDays(new Date(), -1 * DEFAULT_NUM_OF_DAYS), dateOnlyFormat),
    // endDate: format(new Date(), dateOnlyFormat),
  }),
  computed: {
    groupedLogItems(): Map<dateOnly, LogItem[]> {
      return this.logItems.reduce((groups, item) => {
        const date = item.date
        groups.set(date, [...(groups.get(date) || []), item])
        return groups
      }, new Map<dateOnly, LogItem[]>())
    },
    // startDate(): string {
    //   return smallestString(...this.dates);
    // },
    // endDate(): string {
    //   return largestString(...this.dates);
    // },
    dates(): dateOnly[] {
      return [...this.groupedLogItems.keys()].sort(
        (a, b) => (a < b ? -1 : a > b ? 1 : 0) * this.sortOrder
      )
      // const startDate = parseISO(this.startDate);
      // const endDate = parseISO(this.endDate);
      // // console.log(differenceInCalendarDays(startDate, parseISO(this.endDate)))
      // return Array(differenceInCalendarDays(endDate, startDate) + 1)
      //   .fill(undefined)
      //   .map((val, i) => format(addDays(endDate, -1 * i), dateOnlyFormat));
    },
    isSmall(): boolean {
      return this.$vuetify.breakpoint.xsOnly
    },
    categories(): string[] {
      return [
        ...new Set<string>(
          this.value
            // .filter((li) =>
            //   this.filterAll(li, [this.filterStartDate, this.filterEndDate])
            // )
            .map((l: LogItem) => l.category)
        ),
      ]
    },
    types(): string[] {
      return [
        ...new Set<string>(
          this.value
            .filter((li) =>
              this.filterAll(li, [
                // this.filterStartDate,
                // this.filterEndDate,
                this.filterCategory,
                (z) => !['harvest', 'image'].includes(z.category),
              ])
            )
            .map((l: LogItem) => l.type)
        ),
      ]
    },
    logItems(): LogItem[] {
      return this.value.filter((li) =>
        this.filterAll(li, [
          // this.filterStartDate,
          // this.filterEndDate,
          this.filterCategory,
          this.filterType,
        ])
      )
    },
  },
  methods: {
    getMonthFromDate(date: string): string {
      return format(parseISO(date), 'MMMM yyyy')
    },
    filterAll(li: LogItem, filters: Array<(li: LogItem) => boolean>): boolean {
      return filters.every((filter) => filter(li))
    },
    // filterStartDate(li: LogItem) {
    //   return li.date >= this.startDate;
    // },
    // filterEndDate(li: LogItem) {
    //   return li.date <= this.endDate;
    // },
    filterCategory(li: LogItem) {
      return this.category
        ? li.category === this.category
        : this.categoryFilter.length < 1 ||
            this.categoryFilter.includes(li.category)
    },
    filterType(li: LogItem): boolean {
      return this.typeFilter.length < 1 || this.typeFilter.includes(li.type)
    },
  },
})
